// extracted by mini-css-extract-plugin
export default {"modal-tab":"ModuleBuilder_modal-tab__m9Iml","details-tab":"ModuleBuilder_details-tab__GFLrE"};